import { useLocation, useNavigate } from 'react-router-dom';
import './WaitBackup.css';
import { TbBarrierBlock } from "react-icons/tb";
import { useBackup } from '../../contexts/backup';
import { useEffect } from 'react';

export function WaitBackup() {
	const location = useLocation();
	const navigate = useNavigate();
	const { backup, error } = useBackup();

	useEffect(() => {
		if (!location.state.ref) return;
		if (!backup || error || backup.currentStage >= backup.totalImportingStages) {
			navigate(location.state.ref);
		}
	}, [backup]);

	return (
		<div className='container'>
			<div className='wait-backup-wrapper'>
				<TbBarrierBlock size={72} color='#ff6d6d' />
				<h2>Acesso não permitido!</h2>
				<p>A unidade selecionada possui uma importação de backup em andamento, aguarde-o finalizar para ter acesso a esta página</p>
				<p>ou selecione outra unidade para gerenciar/monitorar.</p>
			</div>
		</div>
	);
}